import { render } from "./RhAlert.vue?vue&type=template&id=8fa56f80&scoped=true&ts=true"
import script from "./RhAlert.vue?vue&type=script&lang=ts"
export * from "./RhAlert.vue?vue&type=script&lang=ts"

import "./RhAlert.vue?vue&type=style&index=0&id=8fa56f80&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fa56f80"]])

export default __exports__